import { Component } from '@angular/core';

@Component({
    selector: 'app-logout-confim',
    templateUrl: './logout-confim.component.html',
    styleUrls: ['./logout-confim.component.scss'],
    standalone: false
})
export class LogoutConfimComponent {
}
